export default __webpack_public_path__ + "static/trustedSectionBg-582246eabfa28946afc183c20be6e22a.png";